export interface Testimonial {
  text: string
  author: string
  role: string
  location: string
}

export const testimonials: Testimonial[] = [
  {
    text: 'I coach 25 to 30 lessons a week and my Sunday nights used to disappear into planning. Now I open the session plans, pick the objective, and I walk onto the range with the structure, drills and progressions already there. The assessment sheets alone changed how I start with a new golfer — I know exactly what to coach next instead of guessing.',
    author: 'Mark Sullivan',
    role: 'PGA Head Professional, 52',
    location: 'Surrey, United Kingdom',
  },
  {
    text: 'What sold me was the practice builder. My players always asked what they should do between lessons and I gave vague answers. Now they leave with a 30-minute plan with targets and scoring, and they come back having actually improved. Retention at my academy is noticeably better this season.',
    author: 'Rachel Bennett',
    role: 'Golf Academy Coach, 38',
    location: 'Vancouver, Canada',
  },
  {
    text: 'I have been teaching for 22 years, so I was sceptical about another product. This is not theory — it is the paperwork and preparation I always meant to build for myself and never had time to finish. The drill library is organized by skill and objective, so I find what I need mid-lesson without breaking the flow.',
    author: 'David Kessler',
    role: 'Teaching Professional, 58',
    location: 'Scottsdale, United States',
  },
  {
    text: 'The junior and group bonus paid for the whole system in one weekend. I run clinics with 12 kids of completely different abilities, and having stations, games and mixed-ability adaptations ready meant no more improvising on the tee. Parents commented on how organized the sessions felt.',
    author: 'Luke Harrington',
    role: 'Junior Development Coach, 34',
    location: 'Melbourne, Australia',
  },
  {
    text: 'My weakness was follow-up. I would coach a great lesson and then lose track of what we worked on. The progress trackers, coaching notes and reassessment sheets fixed that completely. Players see their development written down, and that keeps them booking the next block of lessons.',
    author: 'Fiona MacLeod',
    role: 'Performance Coach, 45',
    location: 'St Andrews, United Kingdom',
  },
]
